import { Container, Row, Col, Badge } from 'react-bootstrap';
import { useLocation, Navigate } from 'react-router-dom';
import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { RiFileCopyFill } from '@remixicon/react';
import Copied from '../../../../components/Copied/Copied';
import { handleCopyToClipboard } from '../../../../utils/helpers.js';
import InfoBanner from '../../../../components/InfoBanner/InfoBanner.jsx';
import useSubscriptionStore from '../../../../stores/subscriptionStore.js';

function PPGeneratedScreen() {
    const { t } = useTranslation();
    const location = useLocation();
    const pp = location.state?.pp;
    const timerRef = useRef(null);
    const [showCopiedModal, setShowCopiedModal] = useState(false);
    const { isDemo } = useSubscriptionStore();

    if (!pp) {
        return <Navigate to="/" />;
    }

    return (
        <>
            <Container className="py-5">
                {isDemo && (
                    <InfoBanner />
                )}
                <Row className="mb-4">
                    <Col xs={12} className="d-flex">
                        <div className="card-custom-content">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3 className="card-title text-uppercase">{t('pp.generatedTitle')}</h3>
                                <RiFileCopyFill
                                    size={18}
                                    onClick={() => handleCopyToClipboard(pp.title, timerRef, setShowCopiedModal)}
                                    role="button"
                                    className="copy-icon"
                                    title={t('buttons.copy')}
                                />
                            </div>
                            <p className="card-text">{pp.title}</p>
                        </div>
                    </Col>
                </Row>

                <Row className="mb-4 g-4">
                    <Col xs={12} md={12} lg={6} className="d-flex">
                        <div className="card-custom-content">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3 className="card-title text-uppercase">{t('pp.slug')}</h3>
                                <RiFileCopyFill
                                    size={18}
                                    onClick={() => handleCopyToClipboard(pp.slug, timerRef, setShowCopiedModal)}
                                    role="button"
                                    className="copy-icon"
                                    title={t('buttons.copy')}
                                />
                            </div>
                            <p className="card-text">{pp.slug}</p>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} className="d-flex">
                        <div className="card-custom-content">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3 className="card-title text-uppercase">{t('pp.metaDescription')}</h3>
                                <RiFileCopyFill
                                    size={18}
                                    onClick={() => handleCopyToClipboard(pp.metaDescription, timerRef, setShowCopiedModal)}
                                    role="button"
                                    className="copy-icon"
                                    title={t('buttons.copy')}
                                />
                            </div>
                            <p className="card-text">{pp.metaDescription}</p>
                        </div>
                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col xs={12} className="d-flex">
                        <div className="card-custom-content">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="d-flex align-items-center gap-2">
                                    <h3 className="card-title text-uppercase">{t('app.content')}</h3>
                                    <Badge bg="light" text="dark">{t('app.html')}</Badge>
                                </div>
                                <RiFileCopyFill
                                    size={20}
                                    onClick={() => handleCopyToClipboard(pp.privacyPolicyHtml, timerRef, setShowCopiedModal)}
                                    role="button"
                                    className="copy-icon"
                                    title={t('pp.copyHtml')}
                                />
                            </div>
                            <div className="max-h-600 overflow-y-auto hide-scrollbar" dangerouslySetInnerHTML={{ __html: pp.privacyPolicyHtml }} />
                        </div>
                    </Col>
                </Row>
            </Container>

            <Copied
                show={showCopiedModal}
                onHide={() => setShowCopiedModal(false)}
            />
        </>
    );
}

export default PPGeneratedScreen;
